import { axiosV2 } from "config/@axios";
import i18next from "i18next";
import moment from "dayjs";
import { isMessageRemoved } from "pages/Quarantine/helpers/message";

import * as quarantinesActions from "pages/Quarantine/store/quarantinesActions";
import * as uiActions from "store/actions/uiActions";

export const OPEN_DETAILS = "quarantineActions::openDetails";
export const CLOSE_DETAILS = "quarantineActions::closeDetails";
export const OPEN_RELEASE = "quarantineActions::openRelease";
export const CLOSE_RELEASE = "quarantineActions::closeRelease";
export const RELEASE_QUARANTINE = "quarantineActions::releaseQuarantine";
export const RELEASE_QUARANTINE_SUCCESS =
  "quarantineActions::releaseQuarantineSuccess";
export const RELEASE_QUARANTINE_FAILED =
  "quarantineActions::releaseQuarantineFailed";
export const OPEN_ADD_TO_WLIST = "quarantineActions::openAddToWList";
export const CLOSE_ADD_TO_WLIST = "quarantineActions::closeAddToWList";
export const ADD_TO_WLIST = "quarantineActions::addToWList";
export const ADD_TO_WLIST_SUCCESS = "quarantineActions::addToWListSuccess";
export const ADD_TO_WLIST_FAILED = "quarantineActions::addToWListFailed";

export const OPEN_DELETE = "quarantineActions::openDelete";
export const CLOSE_DELETE = "quarantineActions::closeDelete";
export const DELETE_QUARANTINE = "quarantineActions::deleteQuarantine";
export const DELETE_QUARANTINE_SUCCESS =
  "quarantineActions::deleteQuarantineSuccess";
export const DELETE_QUARANTINE_FAILED =
  "quarantineActions::deleteQuarantineFailed";
export const OPEN_RESULT = "quarantineActions::openResult";
export const CLOSE_RESULT = "quarantineActions::closeResult";
export const OPEN_SENDER_QUARANTINES =
  "quarantineActions::openSenderQuarantines";
export const CLOSE_SENDER_QUARANTINES =
  "quarantineActions::closeSenderQuarantines";
export const SET_SEARCH_PARAMS = "quarantineActions::setSearchParams";
export const SET_PAGE = "quarantineActions::setPage";

export const openDetails = id => {
  return {
    type: OPEN_DETAILS,
    payload: {
      id
    }
  };
};

export const closeDetails = () => {
  return {
    type: CLOSE_DETAILS
  };
};

export const openRelease = (queueIdFromQueryString = null) => {
  return {
    type: OPEN_RELEASE,
    payload: {
      queueIdFromQueryString
    }
  };
};

export const closeRelease = () => {
  return {
    type: CLOSE_RELEASE
  };
};

export const releaseQuarantine =
  (message_id, { mode = "personal" } = {}) =>
  (dispatch, getState) => {
    const state = getState();
    const isHold = state.quarantine?.searchParams?.type === "hold";
    const _type = isHold ? "hold" : "quarantine";

    dispatch({
      type: RELEASE_QUARANTINE
    });

    return axiosV2
      .post(`quarantines/_bulk`, {
        action: "update",
        data: message_id.map(item => {
          return {
            message_id: item
          };
        })
      })
      .then(res => {
        const data = res.data;
        const removed = message_id.filter(item => isMessageRemoved(item, data));
        const unremoved = message_id.filter(
          item => !isMessageRemoved(item, data)
        );
        const releasedSenders = removed.reduce((acc, id) => {
          const mailfrom =
            state.entities?.quarantines?.byId?.[id]?.mailfrom ||
            state.entities?.singleQuarantine?.byId?.[id]?.mailfrom;

          if (mailfrom && !acc.includes(mailfrom)) {
            acc.push(mailfrom);
          }

          return acc;
        }, []);
        let snackbarBody = {
          message:
            mode === "moderation"
              ? i18next.t(`quarantine:moderation.release.success_${_type}`)
              : i18next.t(`quarantine:release.success_release_${_type}`)
        };

        if (unremoved.length > 0) {
          snackbarBody = {
            message: i18next.t("quarantine:release.remove_result", {
              total: message_id.length,
              removed: removed.length,
              unremoved: unremoved.length
            }),
            actionButton: {
              title: i18next.t("quarantine:buttons.details"),
              func: () => {
                dispatch({ type: OPEN_RESULT });
              }
            }
          };
        }

        dispatch({
          type: RELEASE_QUARANTINE_SUCCESS,
          payload: {
            removeResult: data,
            releasedIds: removed,
            releasedSenders
          }
        });

        dispatch(uiActions.selectAll(false, "quarantines"));

        if (removed.length > 0 && !isHold && mode !== "moderation") {
          dispatch({
            type: OPEN_ADD_TO_WLIST
          });
        }

        dispatch(uiActions.addSnackbar(snackbarBody));
        dispatch(quarantinesActions.deleteItems(removed));
      })
      .catch(err => {
        dispatch({
          type: RELEASE_QUARANTINE_FAILED,
          payload: {
            errorMessage: err.errorMessage
          }
        });
      });
  };

export const SENDER_QUARANTINES_WINDOW_DAYS = 7;

const senderQuarantinesWindow = () => ({
  starttime: moment()
    .subtract(SENDER_QUARANTINES_WINDOW_DAYS, "day")
    .startOf("day")
    .unix(),
  endtime: moment().endOf("day").unix()
});

export const checkSenderQuarantines = () => (dispatch, getState) => {
  const state = getState();
  const { releasedIds = [], releasedSenders = [] } = state.quarantine || {};

  if (releasedSenders.length < 1) {
    return Promise.resolve();
  }

  const { starttime, endtime } = senderQuarantinesWindow();
  const count = state.auth?.settings?.display_mail_count ?? 50;

  const findSenderWithOthers = index => {
    if (index >= releasedSenders.length) {
      return Promise.resolve();
    }

    const mailfrom = releasedSenders[index];

    return axiosV2
      .get("quarantines", {
        params: {
          starttime,
          endtime,
          type: "quarantine",
          mailfrom,
          start: 0,
          count
        }
      })
      .then(res => {
        const rows = Array.isArray(res.data) ? res.data : [];
        const totalCount = parseInt(res.headers["x-total-count"], 10);
        const total = isNaN(totalCount) ? rows.length : totalCount;
        const alreadyReleased = rows.filter(item =>
          releasedIds.includes(item.message_id)
        ).length;
        const others = Math.max(total - alreadyReleased, 0);

        if (others < 1) {
          return findSenderWithOthers(index + 1);
        }

        return dispatch({
          type: OPEN_SENDER_QUARANTINES,
          payload: {
            sender: mailfrom,
            count: others
          }
        });
      })
      .catch(() => findSenderWithOthers(index + 1));
  };

  return findSenderWithOthers(0);
};

export const closeAddToWList = () => dispatch => {
  dispatch(uiActions.selectAll(false, "quarantines"));
  dispatch({
    type: CLOSE_ADD_TO_WLIST
  });

  return dispatch(checkSenderQuarantines());
};

export const closeSenderQuarantines = () => {
  return {
    type: CLOSE_SENDER_QUARANTINES
  };
};

export const showSenderQuarantines = () => (dispatch, getState) => {
  const sender = getState().quarantine?.senderQuarantines?.sender;

  dispatch({
    type: CLOSE_SENDER_QUARANTINES
  });

  if (!sender) {
    return Promise.resolve();
  }

  const { starttime, endtime } = senderQuarantinesWindow();

  return dispatch(
    quarantinesActions.fetchByPage({
      page: 1,
      starttime,
      endtime,
      type: "quarantine",
      mailfrom: sender,
      subject: "",
      header_from: ""
    })
  );
};

export const addToWList = selected => dispatch => {
  dispatch({
    type: ADD_TO_WLIST
  });

  const isBulk = selected?.length > 1;

  const url = isBulk ? `bwlists/_bulk` : `bwlists`;

  let payload;

  if (isBulk) {
    payload = {
      action: "create",
      data: selected.map(address => ({
        address: address,
        type: "W",
        direction: "in"
      }))
    };
  } else {
    payload = {
      direction: "in",
      type: "W",
      address: selected[0]
    };
  }

  return axiosV2
    .post(url, payload)
    .then(() => {
      dispatch({
        type: ADD_TO_WLIST_SUCCESS
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("quarantine:release.success_message_wlist")
        })
      );
      dispatch(uiActions.selectAll(false, "quarantines"));

      return dispatch(checkSenderQuarantines());
    })
    .catch(err => {
      dispatch({
        type: ADD_TO_WLIST_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const openDelete = () => {
  return {
    type: OPEN_DELETE
  };
};

export const closeDelete = () => {
  return {
    type: CLOSE_DELETE
  };
};

export const deleteQuarantine = message_id => dispatch => {
  dispatch({
    type: DELETE_QUARANTINE
  });

  return axiosV2
    .post(`quarantines/_bulk`, {
      action: "delete",
      data: message_id.map(item => {
        return {
          message_id: item
        };
      })
    })
    .then(res => {
      const data = res.data;
      const removed = message_id.filter(item => isMessageRemoved(item, data));
      const unremoved = message_id.filter(
        item => !isMessageRemoved(item, data)
      );
      let snackbarBody = {
        message: i18next.t("quarantine:delete.success_message")
      };

      if (unremoved.length > 0) {
        snackbarBody = {
          message: i18next.t("quarantine:delete.remove_result", {
            total: message_id.length,
            removed: removed.length,
            unremoved: unremoved.length
          }),
          actionButton: {
            title: i18next.t("quarantine:buttons.details"),
            func: () => {
              dispatch({ type: OPEN_RESULT });
            }
          }
        };
      }

      dispatch({
        type: DELETE_QUARANTINE_SUCCESS,
        payload: {
          removeResult: data
        }
      });
      dispatch(quarantinesActions.deleteItems(removed));
      dispatch(uiActions.addSnackbar(snackbarBody));
      dispatch(uiActions.selectAll(false, "quarantines"));
    })
    .catch(err => {
      dispatch({
        type: DELETE_QUARANTINE_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const openResult = () => {
  return {
    type: OPEN_RESULT
  };
};

export const closeResult = () => {
  return {
    type: CLOSE_RESULT
  };
};

export const setSearchParams = params => {
  return {
    type: SET_SEARCH_PARAMS,
    payload: {
      searchParams: params
    }
  };
};

export const setPage = page => {
  return {
    type: SET_PAGE,
    payload: {
      page
    }
  };
};
